export const adminCommissions = {
  "admin.commissions.pageTitle": "Commission Management",
  "admin.commissions.pageDescription": "Manage and view all commission data in the system",

  // Tracker page translations
  "admin.commissions.tracker.title": "Commission Tracker",
  "admin.commissions.tracker.subtitle": "Track detailed commission earnings across all users",
  "admin.commissions.tracker.errorTitle": "Error Loading Tracker",
  "admin.commissions.tracker.errorMessage": "Failed to load commission tracker data",
  "admin.commissions.tracker.retryButton": "Retry",
  
  // Tracker filters
  "admin.commissions.tracker.filters.title": "Filters",
  "admin.commissions.tracker.filters.ancestorUsername": "Ancestor Username",
  "admin.commissions.tracker.filters.ancestorUsernamePlaceholder": "Enter ancestor username",
  "admin.commissions.tracker.filters.referralUsername": "Referral Username",
  "admin.commissions.tracker.filters.referralUsernamePlaceholder": "Enter referral username",
  "admin.commissions.tracker.filters.accountNumber": "Account Number",
  "admin.commissions.tracker.filters.accountNumberPlaceholder": "Enter account number",
  "admin.commissions.tracker.filters.level": "Level",
  "admin.commissions.tracker.filters.levelPlaceholder": "Select level",
  "admin.commissions.tracker.filters.allLevels": "All Levels",
  "admin.commissions.tracker.filters.leftoverCommission": "Leftover Commission",
  "admin.commissions.tracker.filters.leftoverCommissionPlaceholder": "Select option",
  "admin.commissions.tracker.filters.allLeftover": "All",
  "admin.commissions.tracker.filters.leftoverYes": "Yes",
  "admin.commissions.tracker.filters.leftoverNo": "No",
  "admin.commissions.tracker.filters.dateFrom": "Period From",
  "admin.commissions.tracker.filters.dateTo": "Period To",
  "admin.commissions.tracker.filters.commissionMin": "Min Commission",
  "admin.commissions.tracker.filters.commissionMinPlaceholder": "Minimum amount",
  "admin.commissions.tracker.filters.commissionMax": "Max Commission",
  "admin.commissions.tracker.filters.commissionMaxPlaceholder": "Maximum amount",
  "admin.commissions.tracker.filters.profitMin": "Min Profit",
  "admin.commissions.tracker.filters.profitMinPlaceholder": "Minimum profit",
  "admin.commissions.tracker.filters.profitMax": "Max Profit",
  "admin.commissions.tracker.filters.profitMaxPlaceholder": "Maximum profit",
  "admin.commissions.tracker.filters.applyFilters": "Apply Filters",
  "admin.commissions.tracker.filters.clearFilters": "Clear Filters",
  
  // Tracker table
  "admin.commissions.tracker.table.title": "Commission Tracker",
  "admin.commissions.tracker.table.ancestorUsername": "Ancestor",
  "admin.commissions.tracker.table.ancestorName": "Ancestor Name",
  "admin.commissions.tracker.table.referralUsername": "Referral",
  "admin.commissions.tracker.table.referralName": "Referral Name",
  "admin.commissions.tracker.table.accountNumber": "Account",
  "admin.commissions.tracker.table.period": "Period",
  "admin.commissions.tracker.table.leftover": "Leftover",
  "admin.commissions.tracker.table.leftoverYes": "Yes",
  "admin.commissions.tracker.table.leftoverNo": "No",
  "admin.commissions.tracker.table.level": "Level",
  "admin.commissions.tracker.table.levelCompany": "Company",
  "admin.commissions.tracker.table.levelLeftover": "Leftover",
  "admin.commissions.tracker.table.commissionPercent": "Commission %",
  "admin.commissions.tracker.table.commission": "Commission",
  "admin.commissions.tracker.table.profitAccount": "Profit Account",
  "admin.commissions.tracker.table.noData": "No commission tracker data found",
  "admin.commissions.tracker.table.error": "Error loading commission tracker data",
  "admin.commissions.tracker.table.showing": "Showing",
  "admin.commissions.tracker.table.of": "of",
  "admin.commissions.tracker.table.records": "records",

  // Profits page translations
  "admin.commissions.profits.title": "Commissions Profits",
  "admin.commissions.profits.subtitle": "View and analyze commission profit history",
  "admin.commissions.profits.errorTitle": "Error Loading Data",
  "admin.commissions.profits.errorMessage": "Failed to load commission profits data",
  "admin.commissions.profits.retryButton": "Retry",

  // Profits filters section
  "admin.commissions.profits.filters.title": "Filters",
  "admin.commissions.profits.filters.user": "User",
  "admin.commissions.profits.filters.userPlaceholder": "Enter username",
  "admin.commissions.profits.filters.period": "Period",
  "admin.commissions.profits.filters.dateFrom": "From Date",
  "admin.commissions.profits.filters.dateTo": "To Date",
  "admin.commissions.profits.filters.commissionAmount": "Commission Amount",
  "admin.commissions.profits.filters.commissionMin": "Min Commission",
  "admin.commissions.profits.filters.commissionMinPlaceholder": "Minimum amount",
  "admin.commissions.profits.filters.commissionMax": "Max Commission",
  "admin.commissions.profits.filters.commissionMaxPlaceholder": "Maximum amount",
  "admin.commissions.profits.filters.leftoverCommission": "Leftover Commission",
  "admin.commissions.profits.filters.leftoverCommissionPlaceholder": "Select leftover commission",
  "admin.commissions.profits.filters.allLeftover": "All",
  "admin.commissions.profits.filters.leftoverYes": "Yes",
  "admin.commissions.profits.filters.leftoverNo": "No",
  "admin.commissions.profits.filters.applyFilters": "Apply Filters",
  "admin.commissions.profits.filters.clearFilters": "Clear Filters",

  // Profits table section
  "admin.commissions.profits.table.title": "Commission Profits",
  "admin.commissions.profits.table.username": "Username",
  "admin.commissions.profits.table.name": "Name",
  "admin.commissions.profits.table.period": "Period",
  "admin.commissions.profits.table.commissionAmount": "Commission Amount",
  "admin.commissions.profits.table.leftover": "Leftover",
  "admin.commissions.profits.table.leftoverYes": "Yes",
  "admin.commissions.profits.table.leftoverNo": "No",
  "admin.commissions.profits.table.noData": "No commission data found",
  "admin.commissions.profits.table.error": "Error loading commission data",
  "admin.commissions.profits.table.showing": "Showing",
  "admin.commissions.profits.table.of": "of",
  "admin.commissions.profits.table.records": "records",

  // Totals page translations
  "admin.commissions.totals.title": "Commissions Totals",
  "admin.commissions.totals.subtitle": "View and analyze total commission earnings by user",
  "admin.commissions.totals.errorTitle": "Error Loading Data",
  "admin.commissions.totals.errorMessage": "Failed to load commission totals data",
  "admin.commissions.totals.retryButton": "Retry",

  // Totals filters section
  "admin.commissions.totals.filters.title": "Filters",
  "admin.commissions.totals.filters.user": "User",
  "admin.commissions.totals.filters.userPlaceholder": "Enter username",
  "admin.commissions.totals.filters.commissionAmount": "Commission Amount",
  "admin.commissions.totals.filters.commissionMin": "Min Commission",
  "admin.commissions.totals.filters.commissionMinPlaceholder": "Minimum amount",
  "admin.commissions.totals.filters.commissionMax": "Max Commission",
  "admin.commissions.totals.filters.commissionMaxPlaceholder": "Maximum amount",
  "admin.commissions.totals.filters.applyFilters": "Apply Filters",
  "admin.commissions.totals.filters.clearFilters": "Clear Filters",

  // Totals table section
  "admin.commissions.totals.table.title": "Commission Totals",
  "admin.commissions.totals.table.username": "Username",
  "admin.commissions.totals.table.name": "Name",
  "admin.commissions.totals.table.totalCommission": "Total Commissions",
  "admin.commissions.totals.table.lastUpdate": "Last Update",
  "admin.commissions.totals.table.noData": "No commission totals data found",
  "admin.commissions.totals.table.error": "Error loading commission totals data",
  "admin.commissions.totals.table.showing": "Showing",
  "admin.commissions.totals.table.of": "of",
  "admin.commissions.totals.table.records": "records",

  // Balances page translations
  "admin.commissions.balances.title": "Commission Balances",
  "admin.commissions.balances.subtitle": "View and manage commission balance data for all users",
  "admin.commissions.balances.errorTitle": "Error Loading Data",
  "admin.commissions.balances.errorMessage": "Failed to load commission balances data",
  "admin.commissions.balances.retryButton": "Retry",

  // Balances filters section
  "admin.commissions.balances.filters.title": "Filters",
  "admin.commissions.balances.filters.user": "User",
  "admin.commissions.balances.filters.userPlaceholder": "Enter username",
  "admin.commissions.balances.filters.balanceAmount": "Balance Amount",
  "admin.commissions.balances.filters.balanceMinPlaceholder": "Min amount",
  "admin.commissions.balances.filters.balanceMaxPlaceholder": "Max amount",
  "admin.commissions.balances.filters.paidAmount": "Paid Amount",
  "admin.commissions.balances.filters.paidMinPlaceholder": "Min paid",
  "admin.commissions.balances.filters.paidMaxPlaceholder": "Max paid",
  "admin.commissions.balances.filters.applyFilters": "Apply Filters",
  "admin.commissions.balances.filters.clearFilters": "Clear Filters",

  // Balances table section
  "admin.commissions.balances.table.title": "Commission Balances",
  "admin.commissions.balances.table.username": "Username",
  "admin.commissions.balances.table.name": "Name",
  "admin.commissions.balances.table.currentBalance": "Current Balance",
  "admin.commissions.balances.table.totalPaid": "Total Paid",
  "admin.commissions.balances.table.lastUpdate": "Last Update",
  "admin.commissions.balances.table.noData": "No commission balance data found",
  "admin.commissions.balances.table.error": "Error loading commission balance data",
  "admin.commissions.balances.table.loading": "Loading...",
  "admin.commissions.balances.table.showing": "Showing",
  "admin.commissions.balances.table.of": "of",
  "admin.commissions.balances.table.records": "records",

  // Payments page translations
  "admin.commissions.payments.title": "Commission Payments",
  "admin.commissions.payments.subtitle": "Track and manage commission payment history",
  "admin.commissions.payments.errorTitle": "Error Loading Payments",
  "admin.commissions.payments.errorMessage": "Failed to load commission payments data",
  "admin.commissions.payments.retryButton": "Retry",

  // Payments filters section
  "admin.commissions.payments.filters.title": "Filters",
  "admin.commissions.payments.filters.user": "Username",
  "admin.commissions.payments.filters.userPlaceholder": "Enter username",
  "admin.commissions.payments.filters.dateFrom": "Payment Date From",
  "admin.commissions.payments.filters.dateTo": "Payment Date To",
  "admin.commissions.payments.filters.paymentAmountMin": "Min Payment Amount",
  "admin.commissions.payments.filters.paymentAmountMinPlaceholder": "Min amount",
  "admin.commissions.payments.filters.paymentAmountMax": "Max Payment Amount",
  "admin.commissions.payments.filters.paymentAmountMaxPlaceholder": "Max amount",
  "admin.commissions.payments.filters.paymentStatus": "Payment Status",
  "admin.commissions.payments.filters.paymentStatusPlaceholder": "Select status",
  "admin.commissions.payments.filters.allStatuses": "All Statuses",
  "admin.commissions.payments.filters.applyFilters": "Apply Filters",
  "admin.commissions.payments.filters.clearFilters": "Clear Filters",

  // Payments table section
  "admin.commissions.payments.table.title": "Commission Payments",
  "admin.commissions.payments.table.username": "Username",
  "admin.commissions.payments.table.name": "Name",
  "admin.commissions.payments.table.paymentAmount": "Payment Amount",
  "admin.commissions.payments.table.feeAmount": "Fee Amount",
  "admin.commissions.payments.table.netAmount": "Net Amount",
  "admin.commissions.payments.table.paymentDate": "Payment Date",
  "admin.commissions.payments.table.paymentStatus": "Status",
  "admin.commissions.payments.table.paymentAccount": "Payment Account",
  "admin.commissions.payments.table.noData": "No payment records found",
  "admin.commissions.payments.table.error": "Error loading payment data",
  "admin.commissions.payments.table.showing": "Showing",
  "admin.commissions.payments.table.of": "of",
  "admin.commissions.payments.table.records": "records",
  
  // Payment status translations
  "admin.commissions.payments.status.pending": "Pending",
  "admin.commissions.payments.status.paid": "Paid",
  "admin.commissions.payments.status.completed": "Completed",
  "admin.commissions.payments.status.cancelled": "Cancelled",
  "admin.commissions.payments.status.failed": "Failed",
  "admin.commissions.payments.status.rejected": "Rejected",

  // Commission Models page
  "admin.commissions.models.title": "Commission Models",
  "admin.commissions.models.subtitle": "View all commission models and their level structures",
  "admin.commissions.models.errorTitle": "Error Loading Commission Models",
  "admin.commissions.models.errorMessage": "Failed to load commission models data",
  "admin.commissions.models.retryButton": "Retry",
  "admin.commissions.models.loading": "Loading commission models...",

  // Commission Model card
  "admin.commissions.models.card.name": "Model Name",
  "admin.commissions.models.card.description": "Description",
  "admin.commissions.models.card.maxLevels": "Max Levels",
  "admin.commissions.models.card.createdAt": "Created",
  "admin.commissions.models.card.updatedAt": "Last Updated",
  "admin.commissions.models.card.levelTable.title": "Commission Structure",
  "admin.commissions.models.card.levelTable.level": "Level",
  "admin.commissions.models.card.levelTable.percentage": "Commission %",
  "admin.commissions.models.card.noLevels": "No commission levels defined",

  // Manager page translations
  "admin.commissions.manager.title": "Commission Manager",
  "admin.commissions.manager.subtitle": "Calculate and manage monthly commission processing",
  "admin.commissions.manager.form.title": "Monthly Commission Calculation",
  "admin.commissions.manager.form.description": "Select the target month to process commissions",
  "admin.commissions.manager.form.periodLabel": "Target Period",
  "admin.commissions.manager.form.periodHint": "Format: yyyy-mm-01 (e.g.",
  "admin.commissions.manager.form.periodFormatError": "Period must be in format yyyy-mm-01",
  "admin.commissions.manager.form.calculateButton": "Calculate Commissions",
  "admin.commissions.manager.form.calculating": "Calculating...",
  "admin.commissions.manager.results.title": "Commission Calculation Results",
  "admin.commissions.manager.results.description": "Results for processing month",
  "admin.commissions.manager.results.processingMonth": "Processing Month",
  "admin.commissions.manager.results.totalWorkers": "Total Workers",
  "admin.commissions.manager.results.processingDuration": "Processing Time",
  "admin.commissions.manager.results.totalProcessed": "Records Processed",
  "admin.commissions.manager.results.totalFailed": "Records Failed",
  "admin.commissions.manager.results.successRate": "Success Rate",
  "admin.commissions.manager.results.totalCommissionAmount": "Total Commission Amount",
  "admin.commissions.manager.results.totalLeftoverAmount": "Total Leftover Amount",
  "admin.commissions.manager.logs.title": "Commission Processing Logs",
  "admin.commissions.manager.logs.description": "View detailed logs for commission calculations",
  "admin.commissions.manager.logs.filterLabel": "Filter by Month",
  "admin.commissions.manager.logs.searchButton": "Search",
  "admin.commissions.manager.logs.clearButton": "Clear",
  "admin.commissions.manager.logs.showing": "Showing",
  "admin.commissions.manager.logs.records": "records",
  "admin.commissions.manager.logs.noLogs": "No commission logs found",
  "admin.commissions.manager.logs.table.month": "Month",
  "admin.commissions.manager.logs.table.workerId": "Worker ID",
  "admin.commissions.manager.logs.table.status": "Status",
  "admin.commissions.manager.logs.table.processed": "Processed",
  "admin.commissions.manager.logs.table.failed": "Failed",
  "admin.commissions.manager.logs.table.commissionAmount": "Commission Amount",
  "admin.commissions.manager.logs.table.leftoverAmount": "Leftover Amount",
  "admin.commissions.manager.logs.table.startedAt": "Started At",
  "admin.commissions.manager.logs.table.completedAt": "Completed At",
  "admin.commissions.manager.logs.table.duration": "Duration",
  "admin.commissions.manager.error.title": "Error Processing Commissions",
  "admin.commissions.manager.error.message": "An error occurred while processing commissions"
};
